import 'core-js/features/promise'
import 'core-js/features/array/find'
import 'core-js/features/object/assign'
import tippy from 'tippy.js'

const tooltips = tippy('[data-tooltip-template]', {
  content(reference) {
    const id = reference.getAttribute('data-tooltip-template')
    const template = document.querySelector(`#${id}`)
    return template.innerHTML
  },
  allowHTML: true,
  appendTo: () => document.body,
  trigger: 'click',
  interactive: true,
  placement: 'top',
  theme: 'dark',
  maxWidth: 400,
  onShown(instance) {
    const closeButton = instance.popper.querySelector('[data-tooltip-close-button')
    closeButton.focus()
  },
  onHidden(instance) {
    instance.reference.focus()
  }
})

tooltips.forEach(tooltip => {
  const button = tooltip.popper.querySelector('button')
  button.addEventListener('click', () => {
    tooltip.hide()
  })
})

const mediaQuery = window.matchMedia('(min-width: 768px)')

setTooltipPlacement(mediaQuery)

mediaQuery.addListener(() => {
  setTooltipPlacement(mediaQuery)
})

function setTooltipPlacement(mediaQuery) {
  if (mediaQuery.matches) {
    tooltips.forEach(tooltip => {
      tooltip.setProps({
        placement: 'left'
      })
    })
  } else {
    tooltips.forEach(tooltip => {
      tooltip.setProps({
        placement: 'top'
      })
    })
  }
}
